// Manual Stimulus controller registration (esbuild bundler).
// Register each new controller here as the migration progresses.
import { application } from './application';

import FlashController from './flash_controller';
application.register('flash', FlashController);

import PasswordVisibilityController from './password_visibility_controller';
application.register('password-visibility', PasswordVisibilityController);

import PasswordStrengthController from './password_strength_controller';
application.register('password-strength', PasswordStrengthController);

import OtpInputController from './otp_input_controller';
application.register('otp-input', OtpInputController);

import EnvFilterController from './env_filter_controller';
application.register('env-filter', EnvFilterController);

import MenuController from './menu_controller';
application.register('menu', MenuController);

import TemplatesIndexController from './templates_index_controller';
application.register('templates-index', TemplatesIndexController);

import CommandPaletteController from './command_palette_controller';
application.register('command-palette', CommandPaletteController);

import CopyController from './copy_controller';
application.register('copy', CopyController);

import CollapsibleController from './collapsible_controller';
application.register('collapsible', CollapsibleController);

import ApiExampleController from './api_example_controller';
application.register('api-example', ApiExampleController);

import GenerationsScopeController from './generations_scope_controller';
application.register('generations-scope', GenerationsScopeController);

import VariableSearchController from './variable_search_controller';
application.register('variable-search', VariableSearchController);

import AccountNavController from './account_nav_controller';
application.register('account-nav', AccountNavController);

import TemplateTypeController from './template_type_controller';
application.register('template-type', TemplateTypeController);

import DropzoneController from './dropzone_controller';
application.register('dropzone', DropzoneController);

import TemplateEditorController from './template_editor_controller';
application.register('template-editor', TemplateEditorController);

import VariablesDrawerController from './variables_drawer_controller';
application.register('variables-drawer', VariablesDrawerController);

import BulkEditorController from './bulk_editor_controller';
application.register('bulk-editor', BulkEditorController);

import FillableFieldsController from './fillable_fields_controller';
application.register('fillable-fields', FillableFieldsController);

import ConfigModalController from './config_modal_controller';
application.register('config-modal', ConfigModalController);

import DispatchController from './dispatch_controller';
application.register('dispatch', DispatchController);

import TemplateChannelController from './template_channel_controller';
application.register('template-channel', TemplateChannelController);

import OrganizationNameModalController from './organization_name_modal_controller';
application.register('organization-name-modal', OrganizationNameModalController);

import EditingLockController from './editing_lock_controller';
application.register('editing-lock', EditingLockController);

import LockTakeoverController from './lock_takeover_controller';
application.register('lock-takeover', LockTakeoverController);

import MembersController from './members_controller';
application.register('members', MembersController);

import WorkflowTutorialController from './workflow_tutorial_controller';
application.register('workflow-tutorial', WorkflowTutorialController);
